module.exports = __webpack_public_path__ + "img/student-desk.1cb3a5f5.webp";